import React from 'react';
import { Grid } from '@material-ui/core';
import { THUMBNAIL_WIDTH_LARGE, THUMBNAIL_HEIGHT_LARGE, THUMBNAIL_HEIGHT_SMALL, THUMBNAIL_WIDTH_SMALL } from './constants';
import { TileMode } from './enums';
import { LargeTile } from './LargeTile';
import { SmallTile } from './SmallTile';
export const Tile = (props) => {
    const handleTileSelect = () => {
        if (props.onTileClick && props.tile.isSelectModeOn) {
            props.onTileClick(props.tile.id, !props.tile.isSelected);
        }
    };
    const handleTileClick = () => {
        if (props.onTileClick && !props.tile.isSelectModeOn) {
            props.onTileClick(props.tile.id, false);
        }
    };
    return (React.createElement(Grid, { id: `tile-wrapper-${props.id}`, onClick: handleTileSelect }, props.mode.toLowerCase() === TileMode.LARGE ? (React.createElement(React.Fragment, null,
        React.createElement(LargeTile, Object.assign({}, props.tile, { index: props.index, onTileClick: handleTileClick, height: THUMBNAIL_HEIGHT_LARGE, width: THUMBNAIL_WIDTH_LARGE, onUpdateDescription: props.onUpdateDescription, translateFn: props.translateFn, shouldShowThumbnailForPdf: props.shouldShowThumbnailForPdf, labelValue: props.labelValue })))) : (React.createElement(React.Fragment, null,
        React.createElement(SmallTile, Object.assign({}, props.tile, { index: props.index, onTileClick: handleTileClick, height: props.smallTileHeight || THUMBNAIL_HEIGHT_SMALL, width: props.smallTileWidth || THUMBNAIL_WIDTH_SMALL, shouldShowThumbnailForPdf: props.shouldShowThumbnailForPdf }))))));
};
//# sourceMappingURL=Tile.js.map